<template>
  <div class="content">
    <div class="content__wrapper">
      <lien-utile
        v-for="lien in liensUtiles"
        :key="lien.id"
        :row="lien"
      ></lien-utile>
    </div>
  </div>
</template>

<script>
import lienUtile from '../components/lienUtile'

export default {
  components: {
    lienUtile
  },
  data () {
    return {
      title: 'LIENS UTILES',
      liensUtiles: [
        {
          id: 1,
          class: 'top-row',
          logos: [
            {
              name: 'ImprimeFacile',
              path: '/static/liens-utiles/imprimefacile.png',
              link: 'https://www.imprimefacile.fr'
            },
            {
              name: 'Firopa',
              path: '/static/logos/firopa.png',
              link: 'https://www.firopa.fr'
            },
            {
              name: 'Ingenidoc',
              path: '/static/liens-utiles/ingenidoc.png',
              link: 'https://ingenidoc.fr'
            },
            {
              name: 'Gibert Clarey',
              path: '/static/liens-utiles/gibert-clarey.svg',
              link: 'http://www.gibert-clarey-imprimeurs.fr',
              svg: true
            }
          ]
        },
        {
          id: 2,
          class: 'top-mid-row',
          logos: [
            {
              name: 'Michel Lata',
              path: '/static/liens-utiles/michel-lata.png',
              link: 'http://michel-lata.com'
            },
            {
              name: 'Frazier',
              path: '/static/liens-utiles/frazier.png',
              link: 'https://www.frazier.fr'
            },
            {
              name: 'GraphImprim',
              path: '/static/liens-utiles/graph-imprim.png',
              link: 'https://www.graph-imprim.com'
            },
            {
              name: 'ImpressionLD',
              path: '/static/liens-utiles/impression-ld.jpg',
              link: 'https://impressions-ld.fr'
            }
          ]
        },
        {
          id: 3,
          class: 'bot-mid-row',
          logos: [
            {
              name: 'Martinet hirondelle',
              path: '/static/liens-utiles/martinet-hirondelle.jpg',
              link: 'http://www.martinet-hirondelle.fr'
            },
            {
              name: 'Ruel Etiquettes',
              path: '/static/liens-utiles/ruel-etiquettes.png',
              link: 'http://www.ruel.fr'
            },
            {
              name: 'Tag Notice',
              path: '/static/liens-utiles/tag-notice.png',
              link: 'http://www.tagnotices.fr'
            },
            {
              name: 'TypoCentre',
              path: '/static/liens-utiles/typocentre-black.png',
              link: 'https://typocentre.fr',
              svg: true
            }
          ]
        },
        {
          id: 4,
          class: 'bot-row',
          logos: [
            {
              name: 'Deja Link',
              path: '/static/liens-utiles/deja-link.jpg',
              link: 'http://dejalink.fr'
            },
            {
              name: 'Iropa',
              path: '/static/liens-utiles/iropa.png',
              link: 'https://www.iropa.fr/'
            },
            {
              name: 'Vassel Graphique',
              path: '/static/liens-utiles/vassel-graphique.png',
              link: 'https://www.vasselgraphique.com'
            },
            {
              name: 'Davoise',
              path: '/static/liens-utiles/davoise.png',
              link: 'https://www.davoise.fr'
            },
            {
              name: 'Interfas',
              path: '/static/liens-utiles/interfas.jpg',
              link: 'https://www.interfas.fr'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="css" scoped>
.content,
.content:after {
  width: 100% !important;
}

.content__wrapper {
  padding: 2.5vw;
}

@media screen and (max-width: 768px) {
  .content,
  .content:after {
    width: 100% !important;
    margin: auto;
    background: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/LiensUtiles.vue